import {ModalComponentProps, Block, Button, Card, Dialog, DialogBody, DialogFooter, VF} from '@mc/ui-v4';
import {Form} from 'react-final-form';
import React from 'react';
import {LayerSchemaVO} from '../../../api';
import {WaitForQueryData} from '@mc/react-app-v4';
import {UseQueryResult} from 'react-query';
import {useLayerSchemaTemplates} from '../../../hooks/useLayerSchemaTemplates';

type Props = ModalComponentProps & {onSubmit: (data: {schema: {id: string; name: string; tridaObjektu: string}}) => void};

export const ImportFromLayerSchemaModal: React.FC<Props> = ({onClose, onSubmit}) => {
    const layerSchemaTemplatesQuery: UseQueryResult<LayerSchemaVO[]> = useLayerSchemaTemplates();

    return (
        <Form onSubmit={onSubmit}>
            {({handleSubmit, submitting, form: {change}}) => {
                return (
                    <Dialog onClose={onClose} title={'Import vrstvy podle schématu'}>
                        <DialogBody>
                            <Card>
                                <Block>
                                    <WaitForQueryData queries={[layerSchemaTemplatesQuery]}>
                                        {() => (
                                            <VF.SelectBox
                                                getItemId={(item: LayerSchemaVO) => item?.xsdPath}
                                                name={'schema'}
                                                items={layerSchemaTemplatesQuery.data.map((template: LayerSchemaVO) => ({
                                                    id: template.xsdPath,
                                                    name: template.objektovyTypNazev,
                                                    tridaObjektu: template.tridaObjektu,
                                                }))}
                                                label={'Schéma'}
                                                disabled={submitting}
                                                required
                                            />
                                        )}
                                    </WaitForQueryData>
                                </Block>
                            </Card>
                        </DialogBody>
                        <DialogFooter>
                            <Button disabled={submitting} style={'link'} onClick={onClose}>
                                Zrušit
                            </Button>
                            <Button style={'primary'} disabled={submitting} onClick={handleSubmit}>
                                Založit vrstvu
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
